<mat-form-field [style.width]="width">
  <mat-label>{{"Client" | translate}}</mat-label>
  <input matInput [matAutocomplete]="auto" [(ngModel)]="filter" (ngModelChange)="doFilter()" type="text" >
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" [displayWith]="shortName">
    <mat-option *ngFor="let client of sublist" [value]="client">{{client.shortName}}</mat-option>
  </mat-autocomplete>
</mat-form-field>
